import {message} from "antd";
import {ErrorResponse} from "../../model/models";

export class HttpErrorService {

    static handle(defaultMessageText: string, error: any, notify?: boolean) {
        if (!error) {
            console.error(defaultMessageText);
            if (notify)
                message.error(defaultMessageText);
            return
        }

        let userMessage;
        if (error.response && error.response.data) {
            const errorResponse = error.response.data.error as ErrorResponse;
            userMessage = errorResponse?.userMessage;
        }

        console.error(defaultMessageText, error);
        if (notify)
            message.error(userMessage || defaultMessageText);
    }

    static async handleBlob(defaultMessageText: string, error: any, notify = true) {
        if (error?.response?.data instanceof Blob) {
            const blob = error.response.data;
            const contentType = blob.type;

            try {
                if (contentType.includes("application/json")) {
                    const text = await blob.text();
                    const json = JSON.parse(text);
                    const userMessage = json?.error?.userMessage || defaultMessageText;

                    console.error("API Error (blob):", json.error);
                    if (notify) message.error(userMessage);
                } else {
                    console.error(defaultMessageText, error);
                    if (notify) message.error(defaultMessageText);
                }
            } catch (e) {
                console.error("Errore durante il parsing del blob", e);
                if (notify) message.error(defaultMessageText);
            }
        }
    }


}

